/**
 * Moved to `src/utils/ingredientGrouping.ts`.
 *
 * The grouping logic is pure and is now also used by the step-ingredient
 * resolver, which lives in `src/utils/` and must not import from
 * `src/components/`. This re-export keeps the existing recipe-detail imports
 * working; prefer the utils path in new code.
 */
export {
  groupIngredientsForDisplay,
  type IngredientGroupInput,
  type GroupedBlock,
  type GroupingResult,
} from '../../utils/ingredientGrouping';
